<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="dataRight">
        <div class="stateTable">
          <el-scrollbar>
            <div class="zMsgHeadBtn">
              <el-button @click="goback" size="small" type="primary"
                >{{$t('common.btn.goback')}}</el-button
              >
            </div>
            <div class="zMsgForm">
              <div class="formTitle">{{$t('NavMenu.EnforcementNotes')}}</div>
              <el-form :model="form" ref="form">
                <el-row :gutter="20">
                  <el-col :span="11">
                    <div class="addInfo">
                      <el-form-item
                        :label="$t('GovernmentRegulation.noteTitle')"
                        prop="noteTitle"
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          disabled
                          v-model="form.noteTitle"
                          autocomplete="off"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="11" style="float: right">
                    <div class="addInfo">
                      <el-form-item
                        :label="$t('ContractManagement.contractId')"
                        prop="companyName"
                        :label-width="formLabelWidth"
                      >
                        <el-input
                          disabled
                          v-model="form.companyName"
                          autocomplete="off"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-form-item
                    :label="$t('OTAManagement.describe')"
                    prop="describe"
                    :label-width="formLabelWidth"
                  >
                    <el-input
                      type="textarea"
                      :rows="3"
                      disabled
                      v-model="form.describe"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="11">
                    <div class="addInfo">
                      <el-form-item
                        prop="carFilePath"
                        :label="$t('GovernmentRegulation.carFilePath')"
                        :label-width="formLabelWidth"
                      >
                        <div class="formImg">
                          <div
                            class="colImg"
                            v-for="(item, index) in imgList"
                            :key="index"
                          >
                            <img :src="item.src" />
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="11" style="float: right">
                    <div class="addInfo">
                      <el-form-item
                        prop="sceneFilePath"
                        :label="$t('GovernmentRegulation.sceneFilePath')"
                        :label-width="formLabelWidth"
                      >
                        <div class="formImg">
                          <div
                            class="colImg"
                            v-for="(item, index) in imgLists"
                            :key="index"
                          >
                            <img :src="item.src" />
                          </div>
                        </div>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="dataTable">
              <div class="table-title" style="margin-bottom: 10px;">{{$t('GovernmentRegulation.companyReplyMessage')}}</div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
      width="620px"
      class="addDialong"
      :title="$t('common.btn.operateDetail')"
      :visible.sync="dialogDetailsFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="DetailsRorm" :model="DetailsRorm">
        <el-form-item
          prop="companyName"
          :label="$t('common.companyName')+':'"
          :label-width="formLabelWidth"
        >
          <el-input
          disabled
            size="small"
            v-model="DetailsRorm.companyName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="feedbackContent"
          :label="$t('GovernmentRegulation.feedbackContent')+':'"
          :label-width="formLabelWidth"
        >
          <el-input
          disabled
            size="small"
            v-model="DetailsRorm.feedbackContent"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="feedbackTime"
          :label="$t('GovernmentRegulation.feedbackTime')+':'"
          :label-width="formLabelWidth"
        >
          <el-date-picker
          disabled
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :placeholder="$t('common.btn.choseDate')"
            v-model="DetailsRorm.feedbackTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          prop="feedbackFilePath"
          :label="$t('common.picture')"
          :label-width="formLabelWidth"
          style="margin-top: 20px"
        >
          <el-upload
            disabled
            class="companyImg"
            :action="processImg"
            list-type="picture-card"
            :file-list="FileList"
            :limit="4"
          >
          </el-upload>
          <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            class="imgForm"
          >
            <img width="100%" :src="imageUrl" alt="" class="avatar" />
          </el-dialog>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>
    
  </div>
</template>

<script>
import NoteDetail from "./NoteDetail";
export default NoteDetail;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
